import e from"./createTheme.js";var r=e();export{r as default};
//# sourceMappingURL=defaultTheme.js.map
